"use client";

import { sprFlow, sprWithJobIdFlow } from "@/constants/common";
import { getJobIdFromParams } from "@/helpers/jobs";
import { useMobile } from "@/hooks";
import { useSearchParams } from "next/navigation";
import React, { useState } from "react";

import BasicHeader from "@/components/common/basicHeader";
import Registration from "@/components/registration";
import JobDetail from "@/components/single-page-registration/job-detail";
import ActionButtons from "@/components/single-page-registration/job-detail/common/ActionButtons";

type SinglePageRegProps = {
  hostname: string;
  timeLoader: number;
};

const SinglePageRegistration: React.FC<SinglePageRegProps> = ({
  hostname,
  timeLoader,
}) => {
  const isMobile = useMobile();
  const searchParams = useSearchParams();
  const jobId = getJobIdFromParams(searchParams);

  const [isShowReg, setIsShowReg] = useState(false); // only for mobile view in single page registration with job id
  const [jobDetailUrl, setJobDetailUrl] = useState("");
  const setJobUrl = (url: string) => {
    // used to open job details page if on single-page-reg with job id user click on close button of registration
    setJobDetailUrl(url);
  };
  const handleShowReg = () => {
    setIsShowReg(true);
  };

  return jobId ? (
    <div
      className="grid h-[100svh] w-screen grid-rows-[auto_minmax(0,1fr)]"
      id={`job-${timeLoader}`}
    >
      {!isShowReg ? (
        <>
          <BasicHeader isMobile={isMobile} hostname={hostname} />
          <div
            id="jobDetails"
            className={`box-border grid grid-cols-1 gap-6 md:grid-cols-3 ${!isMobile ? "pl-4" : ""}`}
          >
            <div className="scrollbar-hide col-span-2 h-full overflow-y-scroll md:py-4 lg:pl-20">
              <JobDetail
                isMobile={isMobile}
                setJobUrl={setJobUrl}
                hostname={hostname}
              />
            </div>
            {!isMobile && (
              <div className="col-span-1 h-full px-6 pt-4 shadow-2xl">
                <Registration
                  flowType={sprWithJobIdFlow}
                  jobDetailUrlForSprWithId={jobDetailUrl}
                  hostname={hostname}
                  timeLoader={timeLoader}
                />
              </div>
            )}
          </div>
          {isMobile && <ActionButtons handleClick={handleShowReg} />}
        </>
      ) : (
        <Registration
          flowType={sprWithJobIdFlow}
          hostname={hostname}
          timeLoader={timeLoader}
        />
      )}
    </div>
  ) : (
    <Registration
      flowType={sprFlow}
      hostname={hostname}
      timeLoader={timeLoader}
    />
  );
};
``;
export default SinglePageRegistration;
